<div>
  <mat-table
    #table
    matSort
    (matSortChange)="onSort.emit($event)"
    [matSortActive]="sortActive"
    [matSortDirection]="sortDirection"
    [dataSource]="dataSource"
    [class.no-dividers]="!dividers"
  >
    <ng-container *ngFor="let column of columns" [cdkColumnDef]="column.key">
      <ng-container [ngSwitch]="column.sortable">
        <ng-container *ngSwitchCase="true">
          <mat-header-cell mat-sort-header *cdkHeaderCellDef>{{
            column.title
          }}</mat-header-cell>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <mat-header-cell *cdkHeaderCellDef>{{
            column.title
          }}</mat-header-cell>
        </ng-container>
      </ng-container>
      <mat-cell *cdkCellDef="let row">
        <ng-container
          [dataListCellPlaceholder]="column.key"
          [payload]="row"
        ></ng-container>
      </mat-cell>
    </ng-container>
    <ng-container *ngIf="headings">
      <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
    </ng-container>
    <ng-container *ngIf="link">
      <a
        *cdkRowDef="let row; columns: displayedColumns"
        (click)="routeToItem(row.id)"
      >
        <mat-row></mat-row>
      </a>
    </ng-container>
    <ng-container *ngIf="!link">
      <mat-row *cdkRowDef="let row; columns: displayedColumns"></mat-row>
    </ng-container>
  </mat-table>
  <mat-paginator
    *ngIf="page && paginator"
    (page)="onPage.emit($event)"
    [length]="page.length"
    [pageIndex]="page.pageIndex"
    [pageSize]="page.pageSize"
    [pageSizeOptions]="[5, 10, 25, 100]"
  >
  </mat-paginator>
</div>
